import { render, staticRenderFns } from "./ModalInactiveUser.vue?vue&type=template&id=08cf243f&scoped=true&"
import script from "./ModalInactiveUser.vue?vue&type=script&lang=ts&"
export * from "./ModalInactiveUser.vue?vue&type=script&lang=ts&"
import style0 from "./ModalInactiveUser.vue?vue&type=style&index=0&id=08cf243f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cf243f",
  null
  
)

export default component.exports